import { ConfigurationRepositoryConfigurationCommandsService } from '@festina/configuration-general-types/configuration/services/ConfigurationRepositoryConfigurationCommandsService'
import { type BranchKey, configurationKeys } from '@festina-life/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useInvalidateBranchAfterHistoryRewrite } from '../branches/useInvalidateBranchAfterHistoryRewrite'

type PullChangesetToWorkspaceArgs = {
  changesetKey: string
  workspaceName: string
  force: boolean
}

export const usePullChangesetToWorkspace = (branchKey: BranchKey) => {
  const invalidateBranch = useInvalidateBranchAfterHistoryRewrite()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      changesetKey,
      workspaceName,
      force,
    }: PullChangesetToWorkspaceArgs) => {
      await ConfigurationRepositoryConfigurationCommandsService.configurationCommandServicePostPullWorkspace(
        {
          requestBody: {
            _type: 'WorkspacePullSpecification',
            branchName: branchKey.name,
            componentName: branchKey.server.toLocaleLowerCase(),
            changesetKey,
            workspaceName,
            force,
          },
        },
      )
    },
    onSuccess: async () => {
      invalidateBranch(branchKey)
      await queryClient.invalidateQueries({
        queryKey: [configurationKeys.allConciseWorkspacesKeyPrefix],
      })
    },
  })
}
